var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C7.5 1 3 5.5 3 11C3 17.75 11.75 25.375 12.125 25.75C12.375 25.875 12.75 26 13 26C13.25 26 13.625 25.875 13.875 25.75C14.25 25.375 23 17.75 23 11C23 5.5 18.5 1 13 1ZM13 23.125C10.375 20.625 5.5 15.25 5.5 11C5.5 6.875 8.875 3.5 13 3.5C17.125 3.5 20.5 6.875 20.5 11C20.5 15.125 15.625 20.625 13 23.125ZM13 6C10.25 6 8 8.25 8 11C8 13.75 10.25 16 13 16C15.75 16 18 13.75 18 11C18 8.25 15.75 6 13 6ZM13 13.5C11.625 13.5 10.5 12.375 10.5 11C10.5 9.625 11.625 8.5 13 8.5C14.375 8.5 15.5 9.625 15.5 11C15.5 12.375 14.375 13.5 13 13.5Z",
    fill: "#00CBAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7926130cefc5077c44f0f61f26e8e8fb.svg";
export { ForwardRef as ReactComponent };